import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import SecurityOverview from './components/SecurityOverview';
import AccessControlPanel from './components/AccessControlPanel';
import PlatformHealthMetrics from './components/PlatformHealthMetrics';
import SecurityActivityLog from './components/SecurityActivityLog';

const SecurityPlatformHealthMonitor = () => {
  const navigate = useNavigate();
  const [user] = useState({
    id: 'admin-001',
    name: 'Sarah Johnson',
    email: 'sarah.johnson@moneytransfer.com',
    role: 'admin'
  });

  const [selectedTimeRange, setSelectedTimeRange] = useState('24h');
  const [activeSection, setActiveSection] = useState('overview');

  const handleLogout = () => {
    navigate('/login');
  };

  const handleBackToDashboard = () => {
    navigate('/admin-dashboard');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header user={user} onLogout={handleLogout} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8 flex items-center justify-between">
          <div>
            <button
              onClick={handleBackToDashboard}
              className="text-primary hover:text-primary/80 flex items-center space-x-2 mb-4"
            >
              <span>←</span>
              <span>Back to Admin Dashboard</span>
            </button>
            <h1 className="text-3xl font-bold text-foreground">Security & Platform Health Monitor</h1>
            <p className="text-muted-foreground mt-2">
              Real-time security oversight and system performance monitoring
            </p>
          </div>
          <div className="flex items-center space-x-4">
            <select
              value={selectedTimeRange}
              onChange={(e) => setSelectedTimeRange(e?.target?.value)}
              className="px-4 py-2 border border-border rounded-lg bg-card text-foreground"
            >
              <option value="1h">Last Hour</option>
              <option value="24h">Last 24 Hours</option>
              <option value="7d">Last 7 Days</option>
              <option value="30d">Last 30 Days</option>
            </select>
            <button className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 flex items-center space-x-2">
              <span>Generate Report</span>
            </button>
          </div>
        </div>

        {/* Security Overview */}
        <div className="mb-8">
          <SecurityOverview timeRange={selectedTimeRange} />
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
          {/* Access Control Panel */}
          <div className="lg:col-span-2">
            <AccessControlPanel />
          </div>

          {/* Platform Health Metrics */}
          <div className="lg:col-span-1">
            <PlatformHealthMetrics timeRange={selectedTimeRange} />
          </div>
        </div>

        {/* Security Activity Log */}
        <div className="mb-8">
          <SecurityActivityLog timeRange={selectedTimeRange} />
        </div>
      </main>
    </div>
  );
};

export default SecurityPlatformHealthMonitor;